import {sortByArray} from "../../utils/array";

export const normalizeFeaturedSearchSections = (sections) => {
  return sortByArray(sections, [
    "bibleCommentaries",
    "concordances",
    "dictionary",
    "bibleVersions",
    "similarParagraphs",
    "egwIndex",
    "aplIndex",
  ], "code");
};
